import SearchBox from '../components/pages/SearchBox';
import { GetStaticProps } from 'next';

export default SearchBox;

export const getStaticProps: GetStaticProps = async () => ({
        props: {},
    });
